if (!customElements.get('theme-product-gallery-arrows')) {
  customElements.define('theme-product-gallery-arrows', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('media-gallery');
      this.viewer = this.parentElement;
      this.list = this.viewer.querySelector('[id^="Slider-Gallery-"]');
      if (!this.gallery || !this.list) return;
      this.onClick = (event) => {
        const button = event.target.closest('[data-product-arrow]');
        if (!button || button.disabled) return;
        const items = this.getItems();
        const current = Math.max(0, items.findIndex((item) => item.dataset.mediaId === this.currentId));
        const next = items[current + (button.dataset.productArrow === 'next' ? 1 : -1)];
        if (!next || !this.gallery.setActiveMedia) return;
        this.currentId = next.dataset.mediaId;
        this.gallery.setActiveMedia(this.currentId, false);
        this.syncButtons();
      };
      this.onSlideChanged = ({ detail }) => {
        if (!detail.currentElement) return;
        this.currentId = detail.currentElement.dataset.mediaId;
        this.getItems().forEach((item) => item.classList.toggle('is-active', item === detail.currentElement));
        this.syncButtons();
      };
      this.addEventListener('click', this.onClick);
      this.viewer.addEventListener('slideChanged', this.onSlideChanged);
      this.observer = new MutationObserver(() => {
        const active = this.getItems().find((item) => item.classList.contains('is-active'));
        if (active) this.currentId = active.dataset.mediaId;
        this.syncButtons();
      });
      this.observer.observe(this.list, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      this.currentId = this.getItems().find((item) => item.classList.contains('is-active'))?.dataset.mediaId;
      this.syncButtons();
    }

    getItems() {
      return Array.from(this.list.querySelectorAll(':scope > [data-media-id]')).filter((item) => !item.hidden);
    }

    syncButtons() {
      const items = this.getItems();
      const index = Math.max(0, items.findIndex((item) => item.dataset.mediaId === this.currentId));
      this.querySelector('[data-product-arrow="previous"]').disabled = index === 0;
      this.querySelector('[data-product-arrow="next"]').disabled = index >= items.length - 1;
      this.toggleAttribute('hidden', items.length < 2);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick);
      this.viewer?.removeEventListener('slideChanged', this.onSlideChanged);
    }
  });
}
